export default __webpack_public_path__ + "static/media/pdfDownload.637be96c.png";